export default {
  onClick: {
    qualifiedClick: {
      properties: {
        tealium_event: 'link',
        page: 'Selection',
        event_details: 'qualified',
        page_url: '/accreditation-tool/onboarding',
        event_category: 'content',
        event_subcategory: '',
        event_action: 'radio',
        event_content: 'qualified',
        site_section: 'ib',
        page_language: 'en',
        page_type: 'application',
        page_customer_group: 'general',
        customer_group: 'general',
        page_business_line: '',
        page_security_level: '40',
        product_category: 'wealth management',
        product_subcategory: '',
        product_id: '',
        page_name: 'ib:accreditation tool:onboarding',
        page_category: 'accreditation tool',
        page_subcategory: 'onboarding',
        raw_datalayer: '5644v2',
        funnel_name: 'accredited investor onboarding',
        funnel_step: '',
        funnel_step_name: 'select',
        lead_event: '',
        application_event: '',
        site_country: 'australia',
        site_region: 'asia pacific',
      },
    },
    notQualifiedClick: {
      properties: {
        tealium_event: 'link',
        page: 'Selection',
        event_details: 'Not Qualified',
        page_url: '/accreditation-tool/onboarding',
        event_category: 'content',
        event_subcategory: '',
        event_action: 'radio',
        event_content: 'Not Qualified',
        site_section: 'ib',
        page_language: 'en',
        page_type: 'application',
        page_customer_group: 'general',
        customer_group: 'general',
        page_business_line: '',
        page_security_level: '40',
        product_category: 'wealth management',
        product_subcategory: '',
        product_id: '',
        page_name: 'ib:accreditation tool:onboarding',
        page_category: 'accreditation tool',
        page_subcategory: 'onboarding',
        raw_datalayer: '5644v2',
        funnel_name: 'accredited investor onboarding',
        funnel_step: '',
        funnel_step_name: 'select',
        lead_event: '',
        application_event: '',
        site_country: 'australia',
        site_region: 'asia pacific',
      },
    },
    accountantCertificateClick: {
      properties: {
        tealium_event: 'link',
        page: 'Selection',
        event_details: 'accountant certificate',
        page_url: '/accreditation-tool/onboarding',
        event_category: 'content',
        event_subcategory: '',
        event_action: 'radio',
        event_content: 'accountant certificate',
        site_section: 'ib',
        page_language: 'en',
        page_type: 'application',
        page_customer_group: 'general',
        customer_group: 'general',
        page_business_line: '',
        page_security_level: '40',
        product_category: 'wealth management',
        product_subcategory: '',
        product_id: '',
        page_name: 'ib:accreditation tool:onboarding',
        page_category: 'accreditation tool',
        page_subcategory: 'onboarding',
        raw_datalayer: '5644v2',
        funnel_name: 'accredited investor onboarding',
        funnel_step: '',
        funnel_step_name: 'select',
        lead_event: '',
        application_event: '',
        site_country: 'australia',
        site_region: 'asia pacific',
      },
    },
    knowledgeTestClick: {
      properties: {
        tealium_event: 'link',
        page: 'Selection',
        event_details: 'knowledge test',
        page_url: '/accreditation-tool/onboarding',
        event_category: 'content',
        event_subcategory: '',
        event_action: 'radio',
        event_content: 'knowledge test',
        site_section: 'ib',
        page_language: 'en',
        page_type: 'application',
        page_customer_group: 'general',
        customer_group: 'general',
        page_business_line: '',
        page_security_level: '40',
        product_category: 'wealth management',
        product_subcategory: '',
        product_id: '',
        page_name: 'ib:accreditation tool:onboarding',
        page_category: 'accreditation tool',
        page_subcategory: 'onboarding',
        raw_datalayer: '5644v3',
        funnel_name: 'accredited investor onboarding',
        funnel_step: '',
        funnel_step_name: 'select',
        lead_event: '',
        application_event: '',
        site_country: 'australia',
        site_region: 'asia pacific',
      },
    },
    professionalInvestorClick: {
      properties: {
        tealium_event: 'link',
        page: 'Selection',
        event_details: 'professional investor',
        page_url: '/accreditation-tool/onboarding',
        event_category: 'content',
        event_subcategory: '',
        event_action: 'radio',
        event_content: 'professional investor',
        site_section: 'ib',
        page_language: 'en',
        page_type: 'application',
        page_customer_group: 'general',
        customer_group: 'general',
        page_business_line: '',
        page_security_level: '40',
        product_category: 'wealth management',
        product_subcategory: '',
        product_id: '',
        page_name: 'ib:accreditation tool:onboarding',
        page_category: 'accreditation tool',
        page_subcategory: 'onboarding',
        raw_datalayer: '5644v34',
        funnel_name: 'accredited investor onboarding',
        funnel_step: '',
        funnel_step_name: 'select',
        lead_event: '',
        application_event: '',
        site_country: 'australia',
        site_region: 'asia pacific',
      },
    },
    downloadCertificate: {
      properties: {
        tealium_event: 'link',
        page: 'Selection',
        event_details: 'download certificate',
        page_url: '/accreditation-tool/onboarding',
        event_category: 'content',
        event_subcategory: '',
        event_action: 'button',
        event_content: 'download certificate',
        site_section: 'ib',
        page_language: 'en',
        page_type: 'application',
        page_customer_group: 'general',
        customer_group: 'general',
        page_business_line: '',
        page_security_level: '40',
        product_category: 'wealth management',
        product_subcategory: '',
        product_id: '',
        page_name: 'ib:accreditation tool:onboarding',
        page_category: 'accreditation tool',
        page_subcategory: 'onboarding',
        raw_datalayer: '5644v4',
        funnel_name: 'accredited investor onboarding',
        funnel_step: '',
        funnel_step_name: 'select',
        lead_event: '',
        application_event: '',
        site_country: 'australia',
        site_region: 'asia pacific',
      },
    },
    downloadDeclaration: {
      properties: {
        tealium_event: 'link',
        page: 'Selection',
        event_details: 'download declaration',
        page_url: '/accreditation-tool/onboarding',
        event_category: 'content',
        event_subcategory: '',
        event_action: 'button',
        event_content: 'download declaration',
        site_section: 'ib',
        page_language: 'en',
        page_type: 'application',
        page_customer_group: 'general',
        customer_group: 'general',
        page_business_line: '',
        page_security_level: '40',
        product_category: 'wealth management',
        product_subcategory: '',
        product_id: '',
        page_name: 'ib:accreditation tool:onboarding',
        page_category: 'accreditation tool',
        page_subcategory: 'onboarding',
        raw_datalayer: '5644v6',
        funnel_name: 'accredited investor onboarding',
        funnel_step: '',
        funnel_step_name: 'select',
        lead_event: '',
        application_event: '',
        site_country: 'australia',
        site_region: 'asia pacific',
      },
    },
    termsAndConditions: {
      properties: {
        tealium_event: 'link',
        page: 'Selection',
        event_details: 'terms and conditions',
        page_url: '/accreditation-tool/onboarding',
        event_category: 'content',
        event_subcategory: '',
        event_action: 'checkbox',
        event_content: 'terms and conditions',
        site_section: 'ib',
        page_language: 'en',
        page_type: 'application',
        page_customer_group: 'general',
        customer_group: 'general',
        page_business_line: '',
        page_security_level: '40',
        product_category: 'wealth management',
        product_subcategory: '',
        product_id: '',
        page_name: 'ib:accreditation tool:onboarding',
        page_category: 'accreditation tool',
        page_subcategory: 'onboarding',
        raw_datalayer: '5644v6',
        funnel_name: 'accredited investor onboarding',
        funnel_step: '',
        funnel_step_name: 'select',
        lead_event: '',
        application_event: '',
        site_country: 'australia',
        site_region: 'asia pacific',
      },
    },
    termsAgree: {
      properties: {
        tealium_event: 'link',
        page: 'Terms and conditions',
        event_details: 'agree',
        page_url: '/accreditation-tool/terms-and-conditions',
        event_category: 'content',
        event_subcategory: '',
        event_action: 'button',
        event_content: 'agree',
        site_section: 'ib',
        page_language: 'en',
        page_type: 'application',
        page_customer_group: 'general',
        customer_group: 'general',
        page_business_line: '',
        page_security_level: '40',
        product_category: 'wealth management',
        product_subcategory: '',
        product_id: '',
        page_name: 'ib:accreditation tool:terms and conditions',
        page_category: 'accreditation tool',
        page_subcategory: 'terms and conditions',
        raw_datalayer: '5644v8',
        funnel_name: 'accredited investor onboarding',
        funnel_step: '',
        funnel_step_name: 'terms and conditions',
        lead_event: '',
        application_event: '',
        site_country: 'australia',
        site_region: 'asia pacific',
      },
    },
    termsClose: {
      properties: {
        tealium_event: 'link',
        page: 'Terms and Conditions',
        event_details: 'close',
        page_url: '/accreditation-tool/terms-and-conditions',
        event_category: 'content',
        event_subcategory: '',
        event_action: 'button',
        event_content: 'close',
        site_section: 'ib',
        page_language: 'en',
        page_type: 'application',
        page_customer_group: 'general',
        customer_group: 'general',
        page_business_line: '',
        page_security_level: '40',
        product_category: 'wealth management',
        product_subcategory: '',
        product_id: '',
        page_name: 'ib:accreditation tool:terms and conditions',
        page_category: 'accreditation tool',
        page_subcategory: 'terms and conditions',
        raw_datalayer: '5644v9',
        funnel_name: 'accredited investor onboarding',
        funnel_step: '',
        funnel_step_name: 'terms and conditions',
        lead_event: '',
        application_event: '',
        site_country: 'australia',
        site_region: 'asia pacific',
      },
    },
    documentUpload: {
      properties: {
        tealium_event: 'link',
        page: 'Accountant Certificate',
        event_details: 'document upload',
        page_url: '/accreditation-tool/accountant-certificate',
        event_category: 'content',
        event_subcategory: '',
        event_action: 'button',
        event_content: 'document upload',
        site_section: 'ib',
        page_language: 'en',
        page_type: 'application',
        page_customer_group: 'general',
        customer_group: 'general',
        page_business_line: '',
        page_security_level: '40',
        product_category: 'wealth management',
        product_subcategory: '',
        product_id: '',
        page_name: 'ib:accreditation tool:accountant certificate',
        page_category: 'accreditation tool',
        page_subcategory: 'accountant certificate',
        raw_datalayer: '5644v11',
        funnel_name: 'accredited investor onboarding - accountant certificate',
        funnel_step: '',
        funnel_step_name: 'accountant certificate',
        lead_event: '',
        application_event: '',
        site_country: 'australia',
        site_region: 'asia pacific',
      },
    },
    dontHaveCertificate: {
      properties: {
        tealium_event: 'link',
        page: 'Accountant Certificate',
        event_details: 'dont have certificate',
        page_url: '/accreditation-tool/accountant-certificate',
        event_category: 'content',
        event_subcategory: '',
        event_action: 'button',
        event_content: 'dont have certificate',
        site_section: 'ib',
        page_language: 'en',
        page_type: 'application',
        page_customer_group: 'general',
        customer_group: 'general',
        page_business_line: '',
        page_security_level: '40',
        product_category: 'wealth management',
        product_subcategory: '',
        product_id: '',
        page_name: 'ib:accreditation tool:accountant certificate',
        page_category: 'accreditation tool',
        page_subcategory: 'accountant certificate',
        raw_datalayer: '5644v12',
        funnel_name: 'accredited investor onboarding - accountant certificate',
        funnel_step: '',
        funnel_step_name: 'accountant certificate',
        lead_event: '',
        application_event: '',
        site_country: 'australia',
        site_region: 'asia pacific',
      },
    },
    downloadAccountantCertificate: {
      properties: {
        tealium_event: 'link',
        page: 'Accountant Certificate',
        event_details: 'download accountant certificate',
        page_url: '/accreditation-tool/accountant-certificate',
        event_category: 'content',
        event_subcategory: '',
        event_action: 'button',
        event_content: 'download accountant certificate',
        site_section: 'ib',
        page_language: 'en',
        page_type: 'application',
        page_customer_group: 'general',
        customer_group: 'general',
        page_business_line: '',
        page_security_level: '40',
        product_category: 'wealth management',
        product_subcategory: '',
        product_id: '',
        page_name: 'ib:accreditation tool:accountant certificate',
        page_category: 'accreditation tool',
        page_subcategory: 'accountant certificate',
        raw_datalayer: '5644v13',
        funnel_name: 'accredited investor onboarding - accountant certificate',
        funnel_step: '',
        funnel_step_name: 'accountant certificate',
        lead_event: '',
        application_event: '',
        site_country: 'australia',
        site_region: 'asia pacific',
      },
    },
    removeDocument: {
      properties: {
        tealium_event: 'link',
        page: 'Accountant Certificate',
        event_details: 'remove document',
        page_url: '/accreditation-tool/accountant-certificate',
        event_category: 'content',
        event_subcategory: '',
        event_action: 'button',
        event_content: 'remove document',
        site_section: 'ib',
        page_language: 'en',
        page_type: 'application',
        page_customer_group: 'general',
        customer_group: 'general',
        page_business_line: '',
        page_security_level: '40',
        product_category: 'wealth management',
        product_subcategory: '',
        product_id: '',
        page_name: 'ib:accreditation tool:accountant certificate',
        page_category: 'accreditation tool',
        page_subcategory: 'accountant certificate',
        raw_datalayer: '5644v14',
        funnel_name: 'accredited investor onboarding - accountant certificate',
        funnel_step: '',
        funnel_step_name: 'accountant certificate',
        lead_event: '',
        application_event: '',
        site_country: 'australia',
        site_region: 'asia pacific',
      },
    },
    backToDashboard: {
      properties: {
        tealium_event: 'link',
        page: 'Accountant Certificate',
        event_details: 'back to dashboard',
        page_url: '/accreditation-tool/accountant-certificate',
        event_category: 'content',
        event_subcategory: '',
        event_action: 'button',
        event_content: 'back to dashboard',
        site_section: 'ib',
        page_language: 'en',
        page_type: 'application',
        page_customer_group: 'general',
        customer_group: 'general',
        page_business_line: '',
        page_security_level: '40',
        product_category: 'wealth management',
        product_subcategory: '',
        product_id: '',
        page_name: 'ib:accreditation tool:accountant certificate',
        page_category: 'accreditation tool',
        page_subcategory: 'accountant certificate',
        raw_datalayer: '5644v16',
        funnel_name: 'accredited investor onboarding - accountant certificate',
        funnel_step: '',
        funnel_step_name: 'submit',
        lead_event: '',
        application_event: '',
        site_country: 'australia',
        site_region: 'asia pacific',
      },
    },
    testRetrieveContinue: {
      properties: {
        tealium_event: 'link',
        page: 'Test Retrieve',
        event_details: 'continue',
        page_url: '/accreditation-tool/knowledge-test/test-retrieve',
        event_category: 'content',
        event_subcategory: '',
        event_action: 'button',
        event_content: 'continue',
        site_section: 'ib',
        page_language: 'en',
        page_type: 'application',
        page_customer_group: 'general',
        customer_group: 'general',
        page_business_line: '',
        page_security_level: '40',
        product_category: 'wealth management',
        product_subcategory: '',
        product_id: '',
        page_name: 'ib:accreditation tool:knowledge test:test retrieve',
        page_category: 'accreditation tool',
        page_subcategory: 'knowledge test',
        raw_datalayer: '5644v26',
        funnel_name: 'accredited investor onboarding - knowledge test',
        funnel_step: '',
        funnel_step_name: 'test retrieve',
        lead_event: '',
        application_event: '',
        site_country: 'australia',
        site_region: 'asia pacific',
      },
    },
    testFailBack: {
      properties: {
        tealium_event: 'link',
        page: 'Test Fail',
        event_details: 'back to dashboard',
        page_url: '/accreditation-tool/knowledge-test/test-failed',
        event_category: 'content',
        event_subcategory: '',
        event_action: 'button',
        event_content: 'back to dashboard',
        site_section: 'ib',
        page_language: 'en',
        page_type: 'application',
        page_customer_group: 'general',
        customer_group: 'general',
        page_business_line: '',
        page_security_level: '40',
        product_category: 'wealth management',
        product_subcategory: '',
        product_id: '',
        page_name: 'ib:accreditation tool:knowledge test:test failed',
        page_category: 'accreditation tool',
        page_subcategory: 'knowledge test',
        raw_datalayer: '5644v28',
        funnel_name: 'accredited investor onboarding - knowledge test',
        funnel_step: '',
        funnel_step_name: 'test failed',
        lead_event: '',
        application_event: '',
        site_country: 'australia',
        site_region: 'asia pacific',
      },
    },
    testPassDocDeclaration: {
      properties: {
        tealium_event: 'link',
        page: 'Test Pass',
        event_details: 'document declaration',
        page_url: '/accreditation-tool/knowledge-test/test-pass',
        event_category: 'content',
        event_subcategory: '',
        event_action: 'button',
        event_content: 'document declaration',
        site_section: 'ib',
        page_language: 'en',
        page_type: 'application',
        page_customer_group: 'general',
        customer_group: 'general',
        page_business_line: '',
        page_security_level: '40',
        product_category: 'wealth management',
        product_subcategory: '',
        product_id: '',
        page_name: 'ib:accreditation tool:knowledge test:test pass',
        page_category: 'accreditation tool',
        page_subcategory: 'knowledge test',
        raw_datalayer: '5644v30',
        funnel_name: 'accredited investor onboarding - knowledge test',
        funnel_step: '',
        funnel_step_name: 'test pass',
        lead_event: '',
        application_event: '',
        site_country: 'australia',
        site_region: 'asia pacific',
      },
    },
    passNodocDeclaration: {
      properties: {
        tealium_event: 'link',
        page: 'Test Pass',
        event_details: 'dont have document declaration',
        page_url: '/accreditation-tool/knowledge-test/test-pass',
        event_category: 'content',
        event_subcategory: '',
        event_action: 'button',
        event_content: 'dont have document declaration',
        site_section: 'ib',
        page_language: 'en',
        page_type: 'application',
        page_customer_group: 'general',
        customer_group: 'general',
        page_business_line: '',
        page_security_level: '40',
        product_category: 'wealth management',
        product_subcategory: '',
        product_id: '',
        page_name: 'ib:accreditation tool:knowledge test:test pass',
        page_category: 'accreditation tool',
        page_subcategory: 'knowledge test',
        raw_datalayer: '5644v31',
        funnel_name: 'accredited investor onboarding - knowledge test',
        funnel_step: '',
        funnel_step_name: 'test pass',
        lead_event: '',
        application_event: '',
        site_country: 'australia',
        site_region: 'asia pacific',
      },
    },
    passDownloadDocDeclaration: {
      properties: {
        tealium_event: 'link',
        page: 'Test Pass',
        event_details: 'download document declaration',
        page_url: '/accreditation-tool/knowledge-test/test-pass',
        event_category: 'content',
        event_subcategory: '',
        event_action: 'button',
        event_content: 'download document declaration',
        site_section: 'ib',
        page_language: 'en',
        page_type: 'application',
        page_customer_group: 'general',
        customer_group: 'general',
        page_business_line: '',
        page_security_level: '40',
        product_category: 'wealth management',
        product_subcategory: '',
        product_id: '',
        page_name: 'ib:accreditation tool:knowledge test:test pass',
        page_category: 'accreditation tool',
        page_subcategory: 'knowledge test',
        raw_datalayer: '5644v32',
        funnel_name: 'accredited investor onboarding - knowledge test',
        funnel_step: '',
        funnel_step_name: 'test pass',
        lead_event: '',
        application_event: '',
        site_country: 'australia',
        site_region: 'asia pacific',
      },
    },
    passRemoveDocument: {
      properties: {
        tealium_event: 'link',
        page: 'Test Pass',
        event_details: 'remove document',
        page_url: '/accreditation-tool/knowledge-test/test-pass',
        event_category: 'content',
        event_subcategory: '',
        event_action: 'button',
        event_content: 'remove document',
        site_section: 'ib',
        page_language: 'en',
        page_type: 'application',
        page_customer_group: 'general',
        customer_group: 'general',
        page_business_line: '',
        page_security_level: '40',
        product_category: 'wealth management',
        product_subcategory: '',
        product_id: '',
        page_name: 'ib:accreditation tool:knowledge test:test pass',
        page_category: 'accreditation tool',
        page_subcategory: 'knowledge test',
        raw_datalayer: '5644v33',
        funnel_name: 'accredited investor onboarding - knowledge test',
        funnel_step: '',
        funnel_step_name: 'test pass',
        lead_event: 'completed',
        application_event: 'submitted',
        site_country: 'australia',
        site_region: 'asia pacific',
      },
    },
  },
  onChange: {},
  onOpen: {},
  onClose: {},
  onNavigate: {},
};
